// Import Cocoen Plugin
import Swiper from "../plugin/swiper";
export default {
  init() {
    // JavaScript to be fired on the home page
    // Swiper Slider
    new Swiper('.slideshow-container', {
      loop: true,
      autoplay: {
        delay: 8500,
        disableOnInteraction: true,
      },

      navigation: {
        nextEl: '.next-slide',
        prevEl: '.previous-slide',
      },
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js